// Web Component für die flexible Collection-Liste
class FlexibleCollectionList extends HTMLElement {
    // Wird beim Erstellen einer neuen Instanz aufgerufen
    constructor() {
        super(); // Ruft den Konstruktor der Elternklasse auf
        this.container = this; // Die Komponente selbst
        this.slider = this.querySelector('.ds-collection-list__list'); // Die scrollbare Liste
        this.previousButton = this.querySelector('.previous-button'); // Zurück-Button
        this.nextButton = this.querySelector('.next-button'); // Weiter-Button
        
        this.init(); // Initialisiert die Komponente
    }

    // Wird aufgerufen, wenn das Element in das DOM eingefügt wird
    connectedCallback() {
        if (this.isConnected) {
            this.init(); // Erneut initialisieren, falls nötig
        }
    }
    
    // Hauptfunktion zur Initialisierung der Komponente
    init() {
        // Bricht ab, wenn wichtige Elemente fehlen
        if (!this.slider || !this.previousButton || !this.nextButton) return;

        // Funktion zum Ermitteln der Breite eines Collection-Items
        const getItemWidth = () => {
            const item = this.slider.querySelector('.collection-item-wrapper');
            return item ? item.offsetWidth : 200; // Fallback: 200px wenn kein Item gefunden
        };

        // Prüft, ob die Liste scrollbar ist und aktualisiert die Buttons
        const checkScrollable = () => {
            // Ist die Liste breiter als der sichtbare Bereich?
            const canScroll = this.slider.scrollWidth > this.slider.clientWidth + 1;
            // Fügt/entfernt die Klasse 'can-scroll' je nach Scrollbarkeit
            this.container.classList.toggle('can-scroll', canScroll);

            if (canScroll) {
                // Wenn scrollbar, aktualisiere die Button-Zustände
                updateButtonVisibility();
            } else {
                // Wenn nicht scrollbar, deaktiviere beide Buttons
                this.previousButton.classList.add('disabled');
                this.nextButton.classList.add('disabled');
            }
        };

        // Aktualisiert die Sichtbarkeit der Buttons basierend auf der Scroll-Position
        const updateButtonVisibility = () => {
            // Deaktiviert den Zurück-Button, wenn am Anfang
            this.previousButton.classList.toggle('disabled', this.slider.scrollLeft <= 0);
            // Deaktiviert den Weiter-Button, wenn am Ende
            this.nextButton.classList.toggle('disabled', Math.ceil(this.slider.scrollLeft + this.slider.clientWidth) >= this.slider.scrollWidth);
        };

        // Initial prüfen, ob scrollbar
        checkScrollable();

        // ResizeObserver überwacht Größenänderungen und aktualisiert die Scrollbarkeit
        const resizeObserver = new ResizeObserver(checkScrollable);
        resizeObserver.observe(this.slider);
        // Zusätzlich bei Fenstergrößenänderung prüfen
        window.addEventListener('resize', checkScrollable);

        // Bei Scrollen die Button-Sichtbarkeit aktualisieren
        this.slider.addEventListener('scroll', updateButtonVisibility);

        // Klick-Handler für den Zurück-Button
        this.previousButton.addEventListener('click', () => {
            // Berechnet die Scroll-Distanz (Item-Breite + Abstand)
            const scrollAmount = getItemWidth() + 20; // 20px Standardabstand
            // Scrollt nach links
            this.slider.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        });

        // Klick-Handler für den Weiter-Button
        this.nextButton.addEventListener('click', () => {
            // Berechnet die Scroll-Distanz (Item-Breite + Abstand)
            const scrollAmount = getItemWidth() + 20; // 20px Standardabstand
            // Scrollt nach rechts
            this.slider.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        });
    }
}

// Registriert das benutzerdefinierte Element, wenn es noch nicht registriert wurde
if (!customElements.get('ds-flexible-collection-list')) {
    customElements.define('ds-flexible-collection-list', FlexibleCollectionList);
}
    